var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        attrs: { type: "text" },
        scopedSlots: _vm._u([
          {
            key: "append",
            fn: function () {
              return [_vm._v(_vm._s(_vm.currencyName))]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      },
      "el-input",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }